export interface ILegalEntity {
  links: {
    self: string;
  };
  legalEntityId: number;
  legalEntityTypeCode: string;
  legalEntityDesc: string;
  legalEntityType: {
    links: {
      self: string;
    };
    legalEntityTypeId: number;
  };
  countryCode: string;
  address: {
    links: {
      self: string;
    };
    addressId: number;
  };
}

export interface IAuth {
  access_token?: string | null;
  jwt?: string | null;
  customer_id?: number | null | number;
  customer_code?: string | null;
  country_code?: string | null;
  user_id?: string | null | number;
  user_timezone?: string | null;
}

export interface ILanguageSelect {
  languageName: string;
  languageISO: string;
  isSelected: boolean;
}

export type ScriptType = '_private' | '_public';
export interface ChatbotScript {
  name: string;
  src: string;
}

declare global {
  interface Window {
    $aivo: Aivo;
    aivoFn?: AivoFn;
  }
}

export type VerticalProps = 'top' | 'bottom';
export type HorizontalProps = 'left' | 'right';
export type PositionProps = VerticalProps | HorizontalProps;
export interface ChatbotRelativePositionSettings {
  enabled: boolean;
  popupDisabled?: boolean;
  popupPosition?: PositionProps;
  title?: string;
  titlePosition?: HorizontalProps;
}

export interface AivoUserApi {
  get(): void;
  me(): void;
  set(e: AivoUser, t?: any): void;
}

export interface AivoUser {
  countryName: string;
  jwt: string;
  fullName: string;
  userAccount: string;
  name: string;
  email: string;
  IsClosed: string;
  firstName: string;
  lastName: string;
  customField1: string;
  customField1Label: string;
  phoneNumber: string;
}

export interface AivoEntryMessage {
  hideAttachButton(): void;
  showAttachButton(): void;
}

export interface AivoChat {
  addMessage(e: any, a: any): void;
  cleanUpChatHistory(): void;
  close(): void;
  closeToSurvey(): void;
  closeWebview(): void;
  displayCTAOnMinimize(): void;
  embed(): void;
  getUserInteractionData(): void;
  interceptor(): void;
  isWebviewOpen(): void;
  maximize(): void;
  minimize(): void;
  onCloseWindow(fn: () => void): void;
  onMinimizeWindow(fn: () => void): void;
  onOpenWindow(fn: () => void): void;
  open(): void;
  resetWindow(): void;
  scrollToEnd(): void;
  sendMessage(e: any): void;
  setConditions(e: any): void;
  setHeaderZendesk(e: any): void;
  showCloseIcon(): void;
  surveyWebviewStatus(): void;
}

export interface AivoHideLauncher {
  hide(): void;
  hideSticky(e: any): void;
  remove(): void;
  show(): void;
}

export interface AivoQuery {
  exists(): void;
  onShowAdwert(): void;
}

export interface AivoSubscribe {
  onBlurDocument(): void;
  onCloseChatButtons(): void;
  onCloseDerivationLive(): void;
  onCloseSurvey(): void;
  onCloseVideoCall(): void;
  onCloseWebview(): void;
  onCloseWindow(): void;
  onDerivationLive(): void;
  onFeedbackIntention(): void;
  onFirstInteraction(): void;
  onIncomingVideoCall(): void;
  onIncomingVideoCallEnd(): void;
  onInteraction(): void;
  onMinimizeInWindow(): void;
  onOpenMaximize(): void;
  onOpenWebview(): void;
  onOpenWindow(): void;
  onSelectedButtonCarousel(): void;
  onSelectedSurvey(): void;
  onShowAdwert(): void;
  onShowButton(): void;
  onShowCarousel(): void;
  onShowForm(): void;
  onShowSurvey(): void;
  onShowVideoCall(): void;
  onSubmitForm(): void;
  onSubmitSurvey(): void;
}

export interface Aivo {
  status?: string;
  run(token: string, a?: any, n?: any): void;
  ready(callback: () => void): void;
  registerTokenForExternalZendesk?(f: () => void): void;
  chat: AivoChat;
  hideLauncher: AivoHideLauncher;
  query: AivoQuery;
  subscribe: AivoSubscribe;
  user: AivoUserApi;
}

export interface AivoFn {
  init(): void;
  checkAndInsertMainScript(defaultToken: string): void;
  insertScript(src: string, defaultToken: string): void;
  isScriptLoaded(src: string): boolean;
  onNavigationChange(defaultToken: string): void;
  runBot(defaultToken: string): void;
  removeAllAgentbotScripts(): void;
  removeAgentAppContainer(): void;
  isChatOpen: boolean;
}
